// src/features/reports/WprReadOutCore.jsx
//
// Shared presentational core for project read-outs. Pure: no data fetching.
// Used by the legacy WPR WprProjectReadOut and the Projects Weekly Overview
// card so both render status, blockers and milestone footers identically.

import React from "react";
import { T } from "../../app/tokens.js";

export function ReadOutStatusPill({ label, color, bg, testId = "wpr-readout-status-pill" }) {
  return (
    <span
      data-testid={testId}
      style={{
        display: "inline-flex", alignItems: "center", gap: 5,
        fontSize: T.fsXs, fontWeight: T.fwSemibold, padding: "2px 10px",
        borderRadius: 6, background: bg, color, whiteSpace: "nowrap", flexShrink: 0,
      }}
    >
      <span style={{ display: "inline-block", width: 6, height: 6, borderRadius: "50%", background: color, flexShrink: 0 }} />
      {label}
    </span>
  );
}

export function ReadOutBlockerCallout({ text, title = "Blocker", testId = "wpr-readout-blocker" }) {
  return (
    <div
      data-testid={testId}
      style={{
        background: T.utilRed, border: `1px solid ${T.redRing}`, borderRadius: 6,
        padding: "10px 14px", marginBottom: 14, display: "flex", gap: 10, alignItems: "flex-start",
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 18, height: 18, borderRadius: "50%", background: T.red, color: T.white,
          fontSize: T.fsXs, fontWeight: T.fwBold, display: "inline-flex",
          alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 1,
        }}
      >!</span>
      <div>
        <div style={{ fontSize: T.fsXs, fontWeight: T.fwBold, color: T.red, marginBottom: 3 }}>{title}</div>
        <div style={{ fontSize: T.fsSm, color: T.dark, lineHeight: 1.55 }}>{text}</div>
      </div>
    </div>
  );
}

export function ReadOutMilestoneFooter({ milestone, testId }) {
  return (
    <div
      data-testid={testId}
      style={{
        marginTop: 12, paddingTop: 10, borderTop: `1px solid ${T.border}`,
        fontSize: T.fsSm, color: T.mid, display: "flex", gap: 6, alignItems: "baseline",
      }}
    >
      <span style={{ fontWeight: T.fwBold, color: T.dark }}>Next milestone:</span>
      {milestone}
    </div>
  );
}

export function ReadOutSectionLabel({ children, style }) {
  return (
    <div style={{
      fontSize: T.fsXxs, fontWeight: T.fwBold, color: T.mid, textTransform: "uppercase",
      letterSpacing: ".07em", marginBottom: 6, ...style,
    }}>
      {children}
    </div>
  );
}
